import ordersApi from "@/api/order";

const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    orders: null,
}
export const mutationTypes = {
    clearOrders: '[orders] clearOrders',
    appendOrders: '[orders] appendOrders',
    setIsLoading: '[orders] setIsLoading',
    setIsMore: '[orders] setIsMore',
    setNextPage: '[order] setNextPage'
}
export const actionTypes = {
    getOrders: '[orders] getOrders',
    getOrder: '[orders] getOrder',
    cancelOrder: '[orders] cancelOrder',
}

export const getterTypes = {
    orders: '[orders] orders',
    isLoading: '[orders] isLoading',
    isMore: '[orders] isMore'
}
const mutations = {
    [mutationTypes.appendOrders](state, orders) {
        if (state.orders === null){
            const arrProxy = new Proxy(orders, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.orders = arrProxy
        } else {
            orders.forEach((order) => {
                const found = state.orders.find((element) => element.id === order.id);
                if (!found){
                    state.orders.push(order)
                }
            })
        }
    },
    [mutationTypes.clearOrders](state){
        state.orders = null
        state.nextPage = 1
        state.isMore = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    }
}

const getters = {
    [getterTypes.orders]: state => {
        return state.orders
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const actions = {
    [actionTypes.getOrders](context) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            ordersApi
                .getOrders(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendOrders, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.getOrder](context, orderId) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        return new Promise(resolve => {
            ordersApi
                .getOrderById(credentials, orderId)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.setIsLoading, false)
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.cancelOrder](context, orderId) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        return new Promise(resolve => {
            ordersApi
                .cancelOrderById(credentials, orderId)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.setIsLoading, false)
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}